import GeneralActions from './general.actions';

import DemandeRepository from '../repositories/demande.repository';

import {
  $stateProvider
} from '../providers';
import {
  STEPS,
  validateDemandeForStep,
  nextStep,
  prevStep
} from '../utils/routes.util';

export const REQUEST_DEMANDE = 'REQUEST_DEMANDE';
export const RECEIVE_DEMANDE = 'RECEIVE_DEMANDE';
export const FAILURE_DEMANDE = 'FAILURE_DEMANDE';

function reset() {
  return dispatch => {
    dispatch(GeneralActions.taskStarted());
    DemandeRepository.cacheDemande({})
      .then(() => {
        dispatch(receiveDemande({}));
        dispatch(GeneralActions.taskDone());
      }, () => {
        dispatch(failureDemande());
        dispatch(GeneralActions.taskFailed('Une erreur est survenue'));
      });
  };
}

function failureDemande() {
  return {
    type: FAILURE_DEMANDE,
    payload: {}
  };
}

function receiveDemande(demande) {
  return {
    type: RECEIVE_DEMANDE,
    payload: {
      demande
    }
  };
}

function requestDemande() {
  return {
    type: REQUEST_DEMANDE,
    payload: {}
  };
}

function cacheDemandeAndGo(demande, currentStep, back) {
  return dispatch => {
    dispatch(GeneralActions.taskStarted());
    DemandeRepository.cacheDemande(demande)
      .then(() => {
        const nextStepPromise = back ? prevStep(demande, currentStep) : nextStep(demande, currentStep);
        nextStepPromise.then(({
          step,
          updatedDemande
        }) => {
          // Si le calcul de la route ajoute des données dans la demande, on récupère la nouvelle version
          if (updatedDemande) {
            DemandeRepository.cacheDemande(updatedDemande)
              .then(() => {
                dispatch(receiveDemande(updatedDemande));
                dispatch(GeneralActions.taskDone());
                $stateProvider().go(step);
              });
          } else {
            dispatch(receiveDemande(demande));
            dispatch(GeneralActions.taskDone());
            $stateProvider().go(step);
          }
        }, () => {
          dispatch(failureDemande());
          dispatch(GeneralActions.taskFailed('Une erreur est survenue'));
        });
      });
  };
}

function startNewDemande(data) {
  return (dispatch) => {
    dispatch(cacheDemandeAndGo(data, STEPS.HOME));
  };
}

function startSuivieDossier(data) {
  return (dispatch) => {
    dispatch(cacheDemandeAndGo(data, STEPS.HOME));
  };
}

function loadDemande(step) {
  return (dispatch) => {
    dispatch(GeneralActions.taskStarted());
    dispatch(requestDemande());
    DemandeRepository.loadDemande()
      .then((demande) => {
        if (!validateDemandeForStep(demande, step)) {
          dispatch(failureDemande());
          dispatch(GeneralActions.taskFailed('Données non trouvées pour la demande.'));
        } else {
          dispatch(receiveDemande(demande));
          dispatch(GeneralActions.taskDone());
        }
      }, () => {
        dispatch(GeneralActions.taskFailed());
        dispatch(failureDemande());
      });
  };
}

function updateAccueilInterface1(accueilInterface1, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      accueilInterface1
    }).asMutable(), STEPS.ACCUEIL_INTERFACE_1, back));
  };
}

function updateContact(contact, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      contact
    }).asMutable(), STEPS.CONTACT, back));
  };
}

function updateZonePerturbe(zonePerturbe, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      zonePerturbe
    }).asMutable(), STEPS.ZONE_PERTURBE, back));
  };
}

function updateConstat(constat, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      constat
    }).asMutable(), STEPS.CONSTAT, back));
  };
}

function updateAccueilInterface2(accueilInterface2, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      accueilInterface2
    }).asMutable(), STEPS.ACCUEIL_INTERFACE_2, back));
  };
}

function updateAccueilInterface3(accueilInterface3, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({}).asMutable(), STEPS.ACCUEIL_INTERFACE_3, back));
  };
}

function updateEtatChaines(etatChaines, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      etatChaines
    }).asMutable(), STEPS.ETAT_CHAINES, back));
  };
}

function updateReamenagement(reamenagement, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      reamenagement
    }).asMutable(), STEPS.REAMENAGEMENT, back));
  };
}

function updateAntenneAccessible(antenneAccessible, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      antenneAccessible
    }).asMutable(), STEPS.ANTENNE_ACCESSIBLE, back));
  };
}

function updateFinAccueil(fin, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      fin
    }).asMutable(), STEPS.FIN_ACCUEIL, back));
  };
}

function updateInterventionAntenniste(interventionAntenniste, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      interventionAntenniste
    }).asMutable(), STEPS.INTERVENTION_ANTENNISTE, back));
  };
}

function updateSignalementAntenniste(signalementAntenniste, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      signalementAntenniste
    }).asMutable(), STEPS.SIGNALEMENT_ANTENNISTE, back));
  };
}

function updateIncidentDetecte(incidentDetecte, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      incidentDetecte
    }).asMutable(), STEPS.INCIDENT_DETECTE, back));
  };
}

function updateAucunIncidentDetecte(aucunIncidentDetecte, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      aucunIncidentDetecte
    }).asMutable(), STEPS.AUCUN_INCIDENT_DETECTE, back));
  };
}

function updateDysfonctionnementInterface(dysfonctionnementInterface, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      dysfonctionnementInterface
    }).asMutable(), STEPS.DYSFONCTIONNEMENT_INTERFACE, back));
  };
}

function updateConclusion(conclusion, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      conclusion
    }).asMutable(), STEPS.CONCLUSION, back));
  };
}

function updateFinAntenniste(finAntenniste, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      finAntenniste
    }).asMutable(), STEPS.FIN_ANTENNISTE, back));
  };
}

function updateLteInterface1(lteInterface1, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      lteInterface1
    }).asMutable(), STEPS.LTE_INTERFACE_1, back));
  };
}

function updateLteInterface2(lteInterface2, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      lteInterface2
    }).asMutable(), STEPS.LTE_INTERFACE_2, back));
  };
}

function updatePrtvInterface1(prtvInterface1, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvInterface1
    }).asMutable(), STEPS.PRTV_INTERFACE_1, back));
  };
}

function updatePrtvInterface2(prtvInterface2, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvInterface2
    }).asMutable(), STEPS.PRTV_INTERFACE_2, back));
  };
}

function updatePrtvInterface3(prtvInterface3, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvInterface3
    }).asMutable(), STEPS.PRTV_INTERFACE_3, back));
  };
}

function updatePrtvInterface4(prtvInterface4, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvInterface4
    }).asMutable(), STEPS.PRTV_INTERFACE_4, back));
  };
}

function updatePrtvInterface5(prtvInterface5, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvInterface5
    }).asMutable(), STEPS.PRTV_INTERFACE_5, back));
  };
}

function updatePrtv6ToFacture(prtvInterface6, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvInterface6
    }).asMutable(), STEPS.PRTV_INTERFACE_6, back));
  };
}
function updatePrtvDepotFacture(prtvDepotFacture, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvDepotFacture
    }).asMutable(), STEPS.PRTV_DEPOT_FACTURE, back));
  };
}

function updatePrtvDepotFacture2(prtvDepotFacture2, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvDepotFacture2
    }).asMutable(), STEPS.PRTV_DEPOT_FACTURE_2, back));
  };
}

function updatePrtvDepotFacture3(prtvDepotFacture3, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvDepotFacture3
    }).asMutable(), STEPS.PRTV_DEPOT_FACTURE_3, back));
  };
}

function updateSuivieAuthent(suivieAuthent, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      suivieAuthent
    }).asMutable(), STEPS.SUIVIE_AUTHENT, back));
  };
}

function updateSuivieResultat(suivieResultat, back) {
  return (dispatch, getState) => {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      suivieResultat
    }).asMutable(), STEPS.SUIVIE_RESULTAT, back));
  };
}
export default {
  reset,
  startNewDemande,
  updateAccueilInterface1,
  updateAccueilInterface2,
  updateAccueilInterface3,
  updateEtatChaines,
  updateIncidentDetecte,
  updateAucunIncidentDetecte,
  updateDysfonctionnementInterface,
  updateConclusion,
  updateLteInterface1,
  updateLteInterface2,
  updatePrtvInterface1,
  updatePrtvInterface2,
  updatePrtvInterface3,
  updatePrtvInterface4,
  updatePrtvInterface5,
  updatePrtv6ToFacture,
  updatePrtvDepotFacture,
  updatePrtvDepotFacture2,
  updatePrtvDepotFacture3,
  updateZonePerturbe,
  updateContact,
  updateConstat,
  updateFinAntenniste,
  loadDemande,
  updateReamenagement,
  updateAntenneAccessible,
  updateInterventionAntenniste,
  updateSignalementAntenniste,
  updateFinAccueil,
  startSuivieDossier,
  updateSuivieAuthent,
  updateSuivieResultat
};



// WEBPACK FOOTER //
// ./src/actions/demande.actions.js